import WorkOrderSupply from '@/models/WorkOrderSupply/WorkOrderSupply';

export default class WorkOrderSupplyFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.workOrderProcessId  = '';
		this.workOrderProcessWorkOrderProcessNumber = '';
		this.workOrderSupplyNumber = '';
		this.workOrderSupplyDateFrom = '';
		this.workOrderSupplyDateTo = '';
		this.remarkMultiple = '';
		this.lineId  = '';
		this.lineCode = '';
		this.documentStatusId  = '';
		this.documentStatusName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			workOrderProcessId : '0',
			workOrderProcessWorkOrderProcessNumber : '0',
			workOrderSupplyNumber : '0',
			workOrderSupplyDateFrom : '0',
			workOrderSupplyDateTo : '0',
			remarkMultiple : '0',
			lineId : '0',
			lineCode : '0',
			documentStatusId : '0',
			documentStatusName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}